export default "__VITE_ASSET__DPfD9ZDV__"